import { useSiteSettingsRetrieve } from '@/api/gen/endpoints/site-settings'

export const useSiteSettings = () => {
  const { data, isLoading, isError } = useSiteSettingsRetrieve({
    query: {
      staleTime: Infinity,
      gcTime: Infinity,
    },
  })

  return { settings: data, isLoading, isError }
}
